import { orgConstants } from 'constants/org.constants';

export function org_short(state = {}, action) {
  switch (action.type) {
    case orgConstants.ORG_SHORT_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case orgConstants.ORG_SHORT_LIST_SUCCESS:
      return {
        ...state,
        items: action.response,
        listLoading: false
      };
    case orgConstants.ORG_SHORT_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    default:
      return state;
  }
}
